<template>
    <li>
        <div class="tree-item-container" v-bind:class="{active: internalItemIsActive(item)}">
            <div class="item-text">
                <div class="icon expand-icon-stack" v-if="isFolder">
                    <b-icon-plus-square
                        v-if="!isOpen"
                        @click="toggleExpanded"
                    />
                    <b-icon-dash-square
                        v-else
                        @click="toggleExpanded"
                    />
                </div>
                <slot :vi="this" :item="item"/>
            </div>
        </div>
        <ul v-show="isOpen" v-if="isFolder">
            <template v-for="(child, index) in getItemChildren(item)">
                <TreeItem
                    class="sub-item"
                    :key="index"
                    :item="child"
                    :item-is-expanded="itemIsExpanded"
                    :item-is-active="itemIsActive"
                >
                    <template scope="_">
                        <slot :item="_.item" />
                    </template>
                </TreeItem>
            </template>
        </ul>
    </li>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from "vue-class-component";

@Component({
    name: 'TreeItem',
    props:  {
        item: { type: Object, required: true },
        itemChildren: { type: Function, required: false },
        itemIsExpanded: { type: Function, required: false },
        itemIsActive: { type: Function, required: false },
    },
})
class TreeItem extends Vue {
    isOpen: boolean = this.internalItemIsExpanded(this.$props.item);

    get isFolder(): boolean {
        return this.getItemChildren && !!this.getItemChildren(this.$props.item).length;
    }

    toggleExpanded() {
        if (this.isFolder) {
            this.isOpen = !this.isOpen;
        }
    }

    internalItemIsExpanded(item: any): boolean {
        return this.$props.itemIsExpanded ? this.$props.itemIsExpanded(item) : true;
    }

    internalItemIsActive(item: any): boolean {
        return this.$props.itemIsActive ? this.$props.itemIsActive(item) : false;
    }

    getItemChildren(item: any): any[] {
        return this.$props.itemChildren ? this.$props.itemChildren(item) : [];
    }
}
export default TreeItem;
</script>

<style lang="scss" scoped>
    @import '../../custom1.scss';

    .tree-item-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        &.active {
            background-color: lighten($bg-color, 25%);
        }

        &:hover {
            background-color: $primary;
        }

        .item-text {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            font-size: 1.15em;
            cursor: pointer;
            padding-left: 0.5em;
            flex-grow: 1;
            width: 100%;

            .icon {
                @include no-select;

                flex-grow: 0;
                margin-right: 0.5em;

                &:empty {
                    display: none;
                }
            }

            .item-data-container {
                flex-grow: 1;
                width: 100%;
            }
        }

        .item-actions {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 0 0.5em 0 0;

            li {
                margin-left: 0.5em;
                cursor: pointer;
            }

            .action {

                &.active {
                    color: $success;
                }

            }
        }
    }

    ul {
        list-style: none;
        padding: 0 0 0 1.5em;
        margin: 0;
    }

</style>